import { type GenericMap } from "@common/declarations";
import { kebabCase } from "lodash";
import { toMap } from "./array";

export const getProps = <T extends {}>(obj: T, doesMatch: (value: any) => boolean): Array<keyof T> =>
  Object.keys(obj).filter((x) => doesMatch(obj[x])) as Array<keyof T>;

export const toKebab = (obj: GenericMap<any>, convert?: (value: any) => any): GenericMap<any> =>
  toMap(
    Object.keys(obj),
    (x) => kebabCase(x),
    (x) => (convert ? convert(obj[x]) : convert)
  );
